import React from "react";
import { useModal } from "@root/client/modal";
import { ScreenWatcher } from "@common/screenWatcher";
import { LayoutWatcher } from "@common/layoutWatcher";
import { Props } from "./types";
import styles from "./styles.scss";

function Holiday({
  isDiscontinuedLeft,
  isDiscontinuedRight,
  calendarHolidays,
  holiday,
}: Props) {
  const ref = React.useRef<HTMLDivElement | null>(null);

  return (
    <ScreenWatcher
      renderChildren={() => (
        <LayoutWatcher
          renderChildren={({ height: h, width: w }) => {
            const rect = ref.current && ref.current.getBoundingClientRect();
            const width = rect ? rect.width : w;
            const height = rect ? rect.height : h;

            return (
              <div ref={ref} className={styles.holiday}>
                <svg
                  className={styles.background}
                  width={width + 2}
                  height={height + 2}
                >
                  <defs>
                    <filter id="shadow">
                      <feDropShadow
                        dx="0"
                        dy="0"
                        stdDeviation=".5"
                        floodColor="rgba(64, 87, 109, 0.15)"
                      />
                      <feDropShadow
                        dx=".5"
                        dy=".5"
                        stdDeviation="1"
                        floodColor="rgba(47, 64, 80, 0.25)"
                      />
                    </filter>
                  </defs>
                  <path
                    filter="url(#shadow)"
                    d={`
                ${
                  isDiscontinuedLeft
                    ? `
                M0 ${height / 2}
                L10 0
                `
                    : `
                M0 5
                C0 0, 0 0, 5 0
                `
                }
                ${
                  isDiscontinuedRight
                    ? `
                H${width - 10}
                L${width} ${height / 2}            
                `
                    : `
                H${width - 5}
                C${width} 0, ${width} 0, ${width} 5
                `
                }
                ${
                  isDiscontinuedRight
                    ? `
                L${width - 10} ${height}
                `
                    : `
                V${height - 15}
                C${width} ${height}, ${width} ${height}, ${width - 5} ${height}
                L${width - 5} ${height}
                `
                }
                ${
                  isDiscontinuedLeft
                    ? `
                H${10}
                L0 ${height / 2}
                `
                    : `
                H${5}
                C0 ${height}, 0 ${height}, 0 ${height - 15}
                L0 ${height}`
                }
                Z
            `}
                  />
                </svg>
                <div className={styles.main}>
                  <p className={styles.name}>
                    {holiday.name ? holiday.name : `[${calendarHolidays.name}]`}
                  </p>
                </div>
              </div>
            );
          }}
        />
      )}
    />
  );
}

export { Holiday };
